import React from "react";
import Widthcontainer from "../../components/customcomponents/widthcontainer";

function DiscoverSection({ data }) {
   console.log(data);
   return (
      <Widthcontainer className={"blog__discoverSection"}>
         <div className="fixed-width">
            <h2 className="discover_heading">Discover more.. </h2>
            <div className="category__container">
               {Object.entries(data)?.map(([key, value]) => {
                  return (
                     <a href={`/company/blogs/category/${value?._id}`}>
                        <div className="btn discover_btn">
                           <p>{value?.title}</p>
                        </div>
                     </a>
                  );
               })}
            </div>
         </div>
      </Widthcontainer>
   );
}

export default DiscoverSection;
